/**
 * Disable editing of fields marked with the `.gf_readonly` class in Gravity Forms.
 *
 * At the time of writing, this is the recommended way in Gravity Forms documentation.
 *
 * @see https://docs.gravityforms.com/making-a-field-read-only/
 */
document.addEventListener('gform/postRender', (event) => {
    document
        .querySelectorAll(
            '.gf_readonly input[type=text], .gf_readonly textarea'
        )
        .forEach((input) => {
            input.readOnly = true;
            input.ariaReadOnly = true;
        });
});
